import SectionShell from "@/pages/home/components/SectionShell";
import { indexItems } from "@/mocks/home";

export default function IndexSection() {
  return (
    <SectionShell
      id="index"
      num="01"
      eyebrow="OVERVIEW INDEX"
      title="本页索引：五处入口，一条动线"
      desc="不想在多个页面之间来回跳？下面把本页整理的内容按顺序排好，点哪一条就直达对应分区。"
    >
      <div className="flex flex-col divide-y divide-background-200/70">
        {indexItems.map((item) => (
          <a
            key={item.num}
            href={item.anchor}
            className="group flex flex-col gap-3 py-6 transition-colors md:flex-row md:items-center md:gap-8 md:py-7"
          >
            <span className="font-heading text-2xl font-black text-background-400 transition-colors group-hover:text-accent-500 md:text-3xl">
              {item.num}
            </span>
            <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-lg bg-primary-100 text-primary-800 transition-colors group-hover:bg-accent-100 group-hover:text-accent-700">
              <i className={`${item.icon} text-2xl`} />
            </span>
            <span className="flex-1">
              <span className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">
                {item.title}
              </span>
              <span className="mt-2 block max-w-2xl text-sm leading-7 text-foreground-600">
                {item.desc}
              </span>
            </span>
            <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full border border-background-300 text-foreground-600 transition-all group-hover:border-accent-300 group-hover:bg-accent-500 group-hover:text-background-50">
              <i className="ri-arrow-right-line text-lg" />
            </span>
          </a>
        ))}
      </div>
    </SectionShell>
  );
}